<template>
  <section class="why-section">
    <v-container>
      <div class="section-heading section-heading--light">
        <div class="eyebrow">Why choose Mayon</div>
        <h2>Built around accurate results, accessible care, and quality-focused diagnostics.</h2>
      </div>

      <v-row>
        <v-col v-for="item in whyChooseUs" :key="item.title" cols="12" md="6" lg="3">
          <v-card class="why-card" elevation="0">
            <span class="why-card__icon"><i :class="item.icon" aria-hidden="true"></i></span>
            <h3>{{ item.title }}</h3>
            <p>{{ item.text }}</p>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import { whyChooseUs } from '@/data/mayonSite'

export default {
  name: 'WhyChooseUs',
  data() {
    return {
      whyChooseUs
    }
  }
}
</script>

<style lang="scss" scoped>
.why-section {
  background: var(--mayon-navy);
  padding: 5rem 0;
}

.section-heading {
  margin: 0 auto 2.25rem;
  max-width: 760px;
  text-align: center;

  .eyebrow {
    color: var(--mayon-teal);
    font-size: 0.82rem;
    font-weight: 800;
    letter-spacing: 0.09em;
    margin-bottom: 0.7rem;
    text-transform: uppercase;
  }

  h2 {
    color: #ffffff;
    font-size: clamp(2rem, 4vw, 3rem);
    letter-spacing: -0.035em;
    line-height: 1.1;
    margin: 0;
  }
}

.why-card {
  background: rgba(255, 255, 255, 0.065) !important;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
  border-radius: 24px !important;
  height: 100%;
  padding: 1.4rem;
  transition: background 0.18s ease, border-color 0.18s ease, transform 0.18s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.09) !important;
    border-color: rgba(88, 184, 184, 0.34) !important;
    transform: translateY(-2px);
  }

  &__icon {
    align-items: center;
    background: rgba(88, 184, 184, 0.16);
    border-radius: 18px;
    color: var(--mayon-teal);
    display: inline-flex;
    height: 56px;
    justify-content: center;
    margin-bottom: 1.1rem;
    width: 56px;

    i {
      font-size: 1.35rem;
    }
  }

  h3 {
    color: #ffffff;
    font-size: 1.05rem;
    margin-bottom: 0.7rem;
  }

  p {
    color: rgba(255, 255, 255, 0.76);
    line-height: 1.7;
    margin: 0;
  }
}
</style>
